import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { errorCode } from "@/lib/errors";
import { navigate } from "@/lib/pages";

/** How often the pages refresh while open; core takes a status every minute. */
export const REFRESH_MS = 60_000;

/** A signed-out request goes to the sign-in page; that ends the attempt. */
function signedOut(error: unknown): boolean {
  if (errorCode(error) !== "UNAUTHORIZED") return false;
  if (window.location.pathname !== "/sign-in") navigate("/sign-in", { replace: true });
  return true;
}

/**
 * The admin app's query client. While core can't be reached, queries keep trying by themselves
 * (each page shows that); a session that ended goes to the sign-in page.
 */
export function createAdminQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchInterval: REFRESH_MS,
        retry: (count, error) =>
          errorCode(error) === "CORE_UNAVAILABLE" ? true : count < 1 && errorCode(error) === null,
        retryDelay: (count) => Math.min(30_000, 2_000 * 2 ** count),
      },
      mutations: { retry: false },
    },
    queryCache: new QueryCache({ onError: (error) => signedOut(error) }),
    mutationCache: new MutationCache({ onError: (error) => signedOut(error) }),
  });
}
